import styled from '@emotion/styled';
import { nafColor } from '@nafcore/theme';
import { spacing } from '@naf/theme';

export const SeparatorLine = styled.div`
  width: 100%;
  border-top: 1px solid ${nafColor.neutral.neutral2};
  margin: ${spacing.space32} 0;
`;
